module.exports = __webpack_public_path__ + "img/genji.91c42a46.png";